module.exports = __webpack_public_path__ + "static/media/4.6fc66cf9.jpg";